import type { RunState } from '../types';

// The RunState values the UI treats as terminal (stop the live indicator / SSE
// "done"). Mirrors a1ec's RunState enum (db/RunState.kt) minus the in-flight
// QUEUED/RUNNING. Typed via the canonical union so a typo'd or non-existent
// state (e.g. the old phantom INTERRUPTED) fails at compile time.
export const TERMINAL_RUN_STATES: ReadonlySet<RunState> = new Set<RunState>([
  'COMPLETED',
  'FAILED',
  'CANCELLED',
]);

export function isTerminalRunState(state: string | undefined | null): boolean {
  if (!state) return false;
  return (TERMINAL_RUN_STATES as ReadonlySet<string>).has(state);
}
